import React from "react";
import PropTypes from "prop-types";
import pinkSpinner from "./img/loading.gif";
import whiteSpinner from "./img/spinner-white.gif";
import SpinnerImgTag from "./styles/mini-spinner-styles";

const MiniSpinner = ({
  size,
  relative,
  absolute,
  top,
  left,
  right,
  bottom,
  white,
  mobileTop,
  mobileLeft,
  mobileRight,
  mobileBottom,
}) => (
  <SpinnerImgTag
    src={white ? whiteSpinner : pinkSpinner}
    alt="mini spinner loader"
    size={size}
    relative={relative}
    absolute={absolute}
    top={top}
    left={left}
    right={right}
    bottom={bottom}
    mobileTop={mobileTop}
    mobileLeft={mobileLeft}
    mobileRight={mobileRight}
    mobileBottom={mobileBottom}
  />
);

MiniSpinner.propTypes = {
  size: PropTypes.number,
  relative: PropTypes.bool,
  absolute: PropTypes.bool,
  top: PropTypes.number,
  left: PropTypes.number,
  right: PropTypes.number,
  bottom: PropTypes.number,
  mobileTop: PropTypes.number,
  mobileLeft: PropTypes.number,
  mobileRight: PropTypes.number,
  mobileBottom: PropTypes.number,
  white: PropTypes.bool,
};

MiniSpinner.defaultProps = {
  size: PropTypes.isNull,
  relative: PropTypes.isNull,
  absolute: PropTypes.isNull,
  top: PropTypes.isNull,
  left: PropTypes.isNull,
  right: PropTypes.isNull,
  bottom: PropTypes.isNull,
  mobileTop: PropTypes.isNull,
  mobileLeft: PropTypes.isNull,
  mobileRight: PropTypes.isNull,
  mobileBottom: PropTypes.isNull,
  white: PropTypes.isNull,
};

export default MiniSpinner;
